<template>
    <div
        :class="
            `formulate-input-element formulate-input-element--${context.class}`
        "
        :data-type="context.type"
    >
    <div
        :class="{
            show: showFullscreenModal,
            modal: showFullscreenModal,
        }"
        :style="{
            top: showFullscreenModal ? '125px' : undefined,
            'z-index': 900,
        }"
    >
        <div style="display: flex;flex-direction:column;height: 100%;">
            <input
                ref="codemirror"
                type="textarea"
                v-model="context.model"
                v-bind="context.attributes"
                autocomplete="no"
                @blur="context.blurHandler"
            />
            <div
                v-show="showFullscreenModal"
                style="
                    background-color: #fff;
                    padding: 20px;
                    width: 100%;
                ">
                <button
                    type="button"
                    class="btn btn-secondary ml-auto"
                    @click="handleHideFullscreenModal"
                ><i class="fas fa-expand"></i> Exit Fullscreen</button>
            </div>
        </div>
    </div>

        <div class="btn btn-secondary" @click="handleShowFullscreenModal">
            <i class="fas fa-expand"></i> Fullscreen
        </div>
    </div>
</template>

<script>
import CodeMirror from 'codemirror/lib/codemirror.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/css/css.js';
import 'codemirror/addon/display/autorefresh.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/edit/closebrackets.js';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/rubyblue.css';

export default {
    props: {
        context: {
            type: Object,
            required: true
        },
        refresh: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'javascript',
        },
        theme: {
             type: String,
             default: 'rubyblue',
        },
    },
    data() {
        return {
            codeMirror: null,
            showFullscreenModal: false,
        };
    },
    mounted() {
        this.codeMirror = CodeMirror.fromTextArea(
            this.$refs.codemirror,
            {
                mode: this.language,
                theme: this.theme,
                lineNumbers: true,
                autoRefresh: true,
                matchBrackets: true,
                autoCloseBrackets: true,
            }
        );
        this.codeMirror.setSize(null, 500);
        this.codeMirror.setOption('autoRefresh', true);

        // handle chnage event
        this.codeMirror.on('change', cm => {
            const value = cm.getValue();
            this.context.model = value;
            this.$emit('input', value);
        });
    },
    watch: {
        'context.model': {
            immediate: true,
            handler(newValue) {
                if (this.codeMirror) {
                    const value =  this.codeMirror.getValue();
                    if (newValue !== value) {
                        this.codeMirror.setValue(newValue);
                        this.doRefresh();
                   }
                }
            },
        },
        refresh: {
            handler(newValue) {
                if (newValue) {
                    this.doRefresh();
                    this.refresh = false;
                }
            },
        },
    },
    methods: {
        doRefresh() {
            setTimeout(() => {
                this.codeMirror.refresh();
            }, 1);
        },
        handleShowFullscreenModal() {
            this.showFullscreenModal = true;
            this.codeMirror.setSize(null, '100%');
            // Prevent scrolling on body
            document.body.style.position = 'fixed';
            document.body.style.top = `-${window.scrollY}px`;
        },
        handleHideFullscreenModal() {
            this.codeMirror.setSize(null, 500);
            this.showFullscreenModal = false;

            // Reset page scroll
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }
};
</script>
